import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import {
  GET_ADMIN_USERS,
  GET_OLD_ADMIN_USERS,
  UPDATE_CLIENTS,
  GET_CLIENT_USERS_BY_ACCOUNT_ID,
  CREATE_ADMIN_RECENT_VISIT,
  GET_ADMIN_RECENT_VISIT,
  GET_REGISTRATION_PENDING_USERS,
  SEND_ADMIN_CLIENT_INVITE_MAIL,
  DELETE_REGISTRATION_PENDING_USER
} from "./actionTypes"

import {
  getAdminUsersSuccess,
  getAdminUsersError,
  getOldAdminUsersSuccess,
  getOldAdminUsersError,
  getClientUsersByAccountIdSuccess,
  getClientUsersByAccountIdError,
  updateClientSuccess,
  updateClientError,
  createAdminRecentVisitSuccess,
  createAdminRecentVisitError,
  getAdminRecentVisitSuccess,
  getAdminRecentVisitError,
  getRegistrationPendingUsersSuccess,
  getRegistrationPendingUsersError,
  postAdminClientInviteMailSucess,
  postAdminClientInviteMailError,
  deleteRegistrationPendingUserSuccess,
  deleteRegistrationPendingUserError,
} from "./actions"

import { genericGetRequest, genericPutRequest, genericGetRequest_2, genericPostRequest, genericDeleteRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration, isRtbBrand } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminUsers(action) {
  let endpoint = '/api/v1/admin_manage_clients'
  if (action?.isV2AdminClientsAPIEnabled) {
    endpoint = '/api/v2/admin_manage_clients'
  }
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      { ...action.payload?.queryParams },
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminUsersSuccess(response, action.paginated))
  } catch (error) {
    yield put(getAdminUsersError(error))
  }
}

function* onGetOldAdminUsers() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/old_get_clients_index`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getOldAdminUsersSuccess(response))
  } catch (error) {
    yield put(getOldAdminUsersError(error))
  }
}

function* onGetRegistrationPendingUsers(action) {
  try {
    let response = []

    if (!isRtbBrand) {
      let user = bsh_getAdminUserDetails();
      response = yield call(
        genericGetRequest,
        `${AppConfiguration.BACKEND_URL}/api/v1/registration_pending_users`,
        { ...action.payload?.queryParams }, // no query parameters
        {
          Authorization: user.token,
        }
      )
    }
    yield put(getRegistrationPendingUsersSuccess(response))
  } catch (error) {
    yield put(getRegistrationPendingUsersError(error))
  }
}


function* onGetClientUsersByAccountId(action) {
  try {
    let auth_user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_users_by_account`,
      { ...action.payload },
      {
        Authorization: auth_user.token,
      }
    )
    yield put(getClientUsersByAccountIdSuccess(response))
  } catch (error) {
    yield put(getClientUsersByAccountIdError(error))
  }
}

function* onUpdateClientUsers({ payload: client_user }) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/${client_user?.id}`,
      {
        body: JSON.stringify(client_user),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateClientSuccess(response))
  } catch (error) {
    yield put(updateClientError(error))
  }
}
function* onCreateAdminRecentVisit(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/recently_visited_client_users`;
    const request_body = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        "Content-Type": "application/json"
      }
    }
    const response = yield call(genericPostRequest, URL, request_body)
    yield put(createAdminRecentVisitSuccess(response))
  } catch (error) {
    yield put(createAdminRecentVisitError(error))
  }
}
function* onGetAdminAdminRecentVisit() {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/recently_visited_client_users`;
    const request_body = {
      body: {},
      headers: {
        Authorization: user.token,
      }
    }
    const response = yield call(genericGetRequest, URL, request_body.body, request_body.headers)
    yield put(getAdminRecentVisitSuccess(response))
  } catch (error) {
    yield put(getAdminRecentVisitError(error))
  }
}

function* onPostAdminClientInviteMail(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_clients/send_invite_mail`;
    const request_body = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        "Content-Type": "application/json"
      }
    }
    const response = yield call(genericPostRequest, URL, request_body)
    yield put(postAdminClientInviteMailSucess(response))
  } catch (error) {
    yield put(postAdminClientInviteMailError(error))
  }
}

function* onDeleteRegistrationPendingUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/registration_pending_users/${action?.payload}`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteRegistrationPendingUserSuccess(response))
  } catch (error) {
    yield put(deleteRegistrationPendingUserError(error))
  }
}

function* adminUsersSaga() {
  yield takeLatest(GET_ADMIN_USERS, onGetAdminUsers)
  yield takeEvery(GET_OLD_ADMIN_USERS, onGetOldAdminUsers)
  yield takeEvery(GET_CLIENT_USERS_BY_ACCOUNT_ID, onGetClientUsersByAccountId)
  yield takeEvery(UPDATE_CLIENTS, onUpdateClientUsers)
  yield takeEvery(CREATE_ADMIN_RECENT_VISIT, onCreateAdminRecentVisit)
  yield takeEvery(GET_ADMIN_RECENT_VISIT, onGetAdminAdminRecentVisit)
  yield takeEvery(GET_REGISTRATION_PENDING_USERS, onGetRegistrationPendingUsers)
  yield takeEvery(SEND_ADMIN_CLIENT_INVITE_MAIL, onPostAdminClientInviteMail)
  yield takeEvery(DELETE_REGISTRATION_PENDING_USER, onDeleteRegistrationPendingUser)
}

export default adminUsersSaga;
